import React from "react";
import { Icon } from "@clarkinc/zest-design-system";
import WebstaurantIcon from "./Logos/WebstaurantIcon";
import WebstaurantLogo from "~/common/Header/Banner/Logos/StandardLogo";
import SocialIcon from "./SocialIcon";
import MobileCategoryContainer from "./MobileFooterCategoryContainer";
import DesktopCategoryContainer from "./DesktopFooterCategoryContainer";
import spritePath from "~/common/Icons/Zest/remixicon.symbol.v1.svg";
import FastAnchor from "../FastAnchor";

const MainFooter = () => {
  return (
    <div
      id="footer"
      className="wss !flex flex-col md:flex-row md:flex-wrap md:justify-between lz:flex-nowrap py-6 lz:py-7"
    >
      <div className="!flex flex-wrap lz:flex-col xs:w-full lz:max-w-[329px] xxxl:max-w-[500px]">
        <div className="xs:max-w-[500px]">
          <h2 className="m-0">
            <FastAnchor
              aria-label="WebstaurantStore"
              className="!flex items-center gap-x-2"
              href="/"
            >
              <WebstaurantIcon />
              <WebstaurantLogo
                fillColor="#fff"
                fillSecondColor="#fff"
                width="248"
                height="23"
              />
            </FastAnchor>
          </h2>
          <p className="text-sm pt-2-1/2 pb-4 m-0 text-white antialiased md:pt-4 md:pb-6 lz:pb-4">
            As the largest online restaurant supply store, we offer the best
            selection, best prices, and fast shipping to keep your business
            functioning at its best.
          </p>
          <div className="!flex pb-8">
            <SocialIcon
              ariaLabel="Instagram"
              name="ri-instagram-line"
              link="https://www.instagram.com/WebstaurantStore/"
            />
            <SocialIcon
              ariaLabel="YouTube"
              name="ri-youtube-fill"
              link="https://www.youtube.com/user/WebstaurantStore"
            />
            <SocialIcon
              ariaLabel="Facebook"
              name="ri-facebook-circle-fill"
              link="https://www.facebook.com/WebstaurantStore"
            />
            <SocialIcon
              ariaLabel="TikTok"
              name="ri-tiktok-fill"
              link="https://www.tiktok.com/@webstaurantstore"
            />
            <SocialIcon
              ariaLabel="Pinterest"
              name="ri-pinterest-fill"
              link="https://www.pinterest.com/webstaurantstore/"
            />
          </div>
        </div>
      </div>
      <DesktopCategoryContainer />
      <MobileCategoryContainer />
      <div className="!flex flex-col">
        <h2
          className="m-0 text-lg font-bold text-white antialiased leading-normal"
          style={{ textShadow: "none" }}
        >
          Get Quick Help
        </h2>
        <a
          className="mt-2-1/2 block text-center bg-white w-full py-2 rounded text-lg font-bold text-gray-900 md:text-sm md:leading-normal md:py-1 md:font-semibold hover:bg-green-100 md:mt-3-1/2 no-underline"
          href="/ask.html"
        >
          Help Center
        </a>
        <a
          className="mt-3 block text-center w-full py-2 border border-solid border-white rounded text-lg font-bold text-white md:text-sm md:mt-2 md:leading-normal md:py-1 md:font-semibold lz:mt-3 hover:text-black hover:bg-white no-underline"
          href="/trackorder.html"
        >
          Track my Order
        </a>
        <div className="!flex justify-evenly py-5 w-full md:flex-col md:py-2 lz:py-3">
          <a
            className="text-lg font-bold leading-normal text-white antialiased hover:underline md:flex md:text-sm md:items-center md:font-normal no-underline"
            style={{ textShadow: "none" }}
            href="/chat/"
            data-testid="chat-now"
            onClick={(e) => {
              e.preventDefault();
              window.open(
                "/chat/",
                "",
                "width=650,height=700,resizable=1,scrollbars=1",
              );
            }}
          >
            <Icon
              className="mr-2 fill-green-300"
              size="2xsmall"
              name="ri-chat-4-line"
              spriteSheetHref={spritePath}
            />
            Chat Online
          </a>
          <a
            className="text-lg leading-normal font-bold text-white antialiased hover:underline md:flex md:text-sm md:items-center md:font-normal md:mt-2 no-underline"
            style={{ textShadow: "none" }}
            href="/shipping_time_details.html"
          >
            <Icon
              className="mr-2 fill-green-300"
              width="12"
              height="12"
              name="ri-truck-line"
              spriteSheetHref={spritePath}
            />
            Shipping &amp; Delivery
          </a>
        </div>
      </div>
    </div>
  );
};

export default MainFooter;
